import { AdhesionDataInterface } from '../../../../interfaces/dto/sales-portal/adhesion-data/adhesion-data-interface';
import { AdhesionBankingInformationModel } from '../adhesion-banking-information/adhesion-banking-information-model';

export class AdhesionDataModel implements AdhesionDataInterface {
  address?: string;
  agentCode: string = '';
  agentOwner?: string;
  bankingInformation?: AdhesionBankingInformationModel;
  birthDate?: Date;
  contractStartDate?: Date;
  email: string = '';
  firstPaymentMethod?: string;
  gender?: string;
  location?: string;
  name: string = '';
  partnership: string = '';
  paymentFracctioning?: string;
  paymentMethod?: string;
  phone?: string;
  policyHolderIsInsuredPerson: boolean = false;
  postalCode?: string;
  productCatalogCode?: string;
  productType?: string;
  proposalId: string = '';
  taxNumber: string = '';
  token?: string;
  signatureType?: string = '';
  personalIdentificationNumber?: string = '';
  phoneCode?: string = '';
  taxNumberCode?: string = '';
  postalCodePrefix?: string = '';
  consents?: number[] = [];

  constructor(init?: Partial<AdhesionDataModel>) {
    Object.assign(this, init);
  }
}
